import { Check, ClipboardCheck, MessageSquareText } from "lucide-react";
import type { CorrectionTask } from "../../domain/models";

function formatCorrectionDate(value: string) {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return new Intl.DateTimeFormat("tr-TR", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);
}

export function CorrectionDossierPanel({
  task,
  onReviewDecision,
}: {
  task: CorrectionTask;
  onReviewDecision: () => void;
}) {
  const offerUpdated = task.hasOfferChange;

  return (
    <section className="correction-dossier" aria-labelledby="correction-title">
      <div className="correction-dossier-heading">
        <div className="correction-dossier-icon" aria-hidden="true">
          <MessageSquareText size={18} />
        </div>
        <div>
          <span className="section-kicker">Müdür geri bildirimi</span>
          <h2 id="correction-title">Dosyada güncelleme gerekiyor</h2>
          <small>
            {task.requestedBy} · {formatCorrectionDate(task.requestedAt)}
          </small>
        </div>
      </div>

      <p className="correction-dossier-instruction">{task.instruction}</p>

      <div className="correction-dossier-scope">
        <span>Güncellenecek alanlar</span>
        <div>
          {task.fields.length ? (
            task.fields.map((field) => <strong key={field}>{field}</strong>)
          ) : (
            <strong>Teklif koşulları ve uzman gerekçesi</strong>
          )}
        </div>
      </div>

      <ol className="correction-progress" aria-label="Geri dönüş ilerlemesi">
        <li className="is-complete">
          <span>
            <Check size={14} />
          </span>
          <div>
            <strong>Geri bildirim alındı</strong>
            <small>Kapsam netleştirildi</small>
          </div>
        </li>
        <li className={offerUpdated ? "is-complete" : "is-current"}>
          <span>{offerUpdated ? <Check size={14} /> : "2"}</span>
          <div>
            <strong>Teklifi güncelle</strong>
            <small>
              {offerUpdated
                ? "Değişiklik kaydedildi"
                : "İstenen ticari alanları düzenleyin"}
            </small>
          </div>
        </li>
        <li className={offerUpdated ? "is-current" : "is-upcoming"}>
          <span>3</span>
          <div>
            <strong>Yeniden gönder</strong>
            <small>Seçim ve gerekçeyi Müdüre iletin</small>
          </div>
        </li>
      </ol>

      <div className="correction-dossier-action">
        <div>
          <strong>{offerUpdated ? "Yeniden gönderime hazır" : "Teklif güncellemesi bekleniyor"}</strong>
          <span>
            {offerUpdated
              ? "Teklif değişikliği kaydedildi. Tedarikçi seçimini ve gerekçeyi gözden geçirerek Müdüre iletin."
              : "İlgili teklifi tablodaki Düzenle işleminden güncelleyin; kayıt sonrasında karar adımı açılır."}
          </span>
        </div>
        {offerUpdated ? (
          <button
            type="button"
            className="approve-button"
            onClick={onReviewDecision}
          >
            <ClipboardCheck size={16} /> Kararı gözden geçir
          </button>
        ) : null}
      </div>
    </section>
  );
}
